<template>
    <div>
        <v-app-bar flat bottom>
            <v-toolbar-title>
                <router-link :to="{ name: 'dashboard' }" class="logo-link">
                    <span class="main-title">{{ $t('app.title') }}</span>
                    <span class="subtitle">{{ $t('app.subtitle') }}</span>
                </router-link>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn
                v-if="$route.name !== 'dashboard'"
                :to="{ name: 'dashboard'}"
                text
            >
                <v-icon>mdi-view-dashboard</v-icon>
                {{ $t('user.dashboard') }}
            </v-btn>

            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn text v-on="on">
                        <v-icon>mdi-account</v-icon>
                        {{ user.firstname }} {{ user.name }}
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-item :to="{ name: 'dashboard'}">
                        <v-list-item-icon>
                            <v-icon>mdi-view-dashboard</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            {{ $t('user.dashboard') }}
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-on:click="showRadarForm=true">
                        <v-list-item-icon>
                            <v-icon>mdi-plus</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            {{ $t('controls.create_radar') }}
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item :to="{ name: 'profile'}">
                        <v-list-item-icon>
                            <v-icon>mdi-account</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            {{ $t('user.profile') }}
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item :to="{ name: 'admin'}" v-if="isAdmin">
                        <v-list-item-icon>
                            <v-icon>mdi-account-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            {{ $t('user.admin_panel') }}
                        </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item @click="logout">
                        <v-list-item-icon>
                            <v-icon>mdi-logout</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            {{ $t('auth.login.logout') }}
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>

            <RadarFormDialog :passive="true" :show="showRadarForm" @close="showRadarForm=false"></RadarFormDialog>
        </v-app-bar>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import RadarFormDialog from './radar/RadarFormDialog'

  export default {
    name: 'Toolbar',
    components: { RadarFormDialog },
    data: () => ({
        showRadarForm: false
    }),
    computed: {
      ...mapGetters({
        user: 'user/userInfo',
        isAdmin: 'user/isAdmin'
      })
    },
    methods: {
      logout () {
        this.$store.dispatch('user/logout')
          .then(() => {
            window.location.href = '/'
          })
          .catch(() => {
            window.location.href = '/'
          })
      }
    }
  }
</script>
